import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddIcon from "@mui/icons-material/Add";
import AddProduct from "../../Modals/addProduct";

const ManageProducts = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const [products] = useState([
    {
      id: 1,
      name: "GoGreek Cino",
      description: "Experience the ultimate indulgence with YoGo Matcha, a delightful fusion where the velvety richness of Greek yogurt intertwines with the refreshing vibrancy of matcha. Each sip is a luxurious journey crafted from the finest ingredients, offering a perfect balance of flavor and wellness.",
      type: "size",
      size: "16 Oz Cup",
      price: "3.500 K.D",
      category: "Smoothies",
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 2,
      name: "GoGreek Cino",
      description: "Experience the ultimate indulgence with YoGo Matcha, a delightful fusion where the velvety richness of Greek yogurt intertwines with the refreshing vibrancy of matcha. Each sip is a luxurious journey crafted from the finest ingredients, offering a perfect balance of flavor and wellness.",
      type: "size",
      size: "16 Oz Cup",
      price: "3.500 K.D",
      category: "Smoothies",
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 3,
      name: "Greek Frappe",
      description: "Dive into the world of our Espresso coffee, a true masterpiece crafted from the finest Arabica beans harvested from the most exquisite coffee-growing regions around the globe. Each bean is handpicked with care and roasted to perfection, ensuring that every cup delivers an explosion of rich, bold flavors that dance on your palate.",
      type: "variant",
      variant: "Single Variant",
      price: "3.500 K.D",
      category: "Beverages",
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 4,
      name: "Espresso",
      description: "Dive into the world of our Espresso coffee, a true masterpiece crafted from the finest Arabica beans harvested from the most exquisite coffee-growing regions around the globe. Each bean is handpicked with care and roasted to perfection, ensuring that every cup delivers an explosion of rich, bold flavors that dance on your palate.",
      type: "variant",
      variant: "Double Variant",
      singlePrice: "3.500 K.D",
      doublePrice: "4.500 K.D",
      category: "Beverages",
      createdDate: "01-Sept-2025",
      status: true,
    }
  ]);


  const [type, setType] = React.useState('default');
  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  return (
    <>
      <div className="main_title">
        <h1>Manage Products</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Products
        </p>
      </div>

      {/* Table */}
      <div className="cards mt_20">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
            <div className="form">
              <div className="control_group">
                <Select
                  fullWidth
                  value={type}
                  onChange={handleTypeChange}
                >
                  <MenuItem disabled value="default">Select Category</MenuItem>
                  <MenuItem value="1">Smothies</MenuItem>
                  <MenuItem value="2">Beverages</MenuItem>
                  <MenuItem value="3">Greek Bowl</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              <AddIcon /> Add New Product
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Price</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Featured</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {products.map((row) => (
                <TableRow key={row.id} hover>
                  <TableCell>
                    <div className="user_block no_radius">
                      <figure>
                        <img src="/static/images/placeholder.png" alt="Product" />
                      </figure>
                      <p><b>{row.name}</b></p>
                    </div>
                  </TableCell>

                  <TableCell className="max_c2">
                    <p>{row.description || "-"}</p>
                  </TableCell>

                  <TableCell>{row.category}</TableCell>

                  {/* ---------------- TYPE COLUMN ---------------- */}
                  <TableCell>
                    {row.type === "size" && (
                      <>
                        <strong>Size:</strong> {row.size}
                      </>
                    )}
                    {row.type === "variant" && row.variant}
                  </TableCell>

                  {/* ---------------- PRICE COLUMN ---------------- */}
                  <TableCell>
                    {/* If TYPE is SIZE -> show only one price */}
                    {row.type === "size" && (
                      <span>{row.price}</span>
                    )}

                    {/* Single Variant */}
                    {row.type === "variant" && row.variant === "Single Variant" && (
                      <span>{row.price}</span>
                    )}

                    {/* Double Variant */}
                    {row.type === "variant" && row.variant === "Double Variant" && (
                      <>
                        <div><strong>Single:</strong> {row.singlePrice}</div>
                        <div><strong>Double:</strong> {row.doublePrice}</div>
                      </>
                    )}
                  </TableCell>

                  <TableCell>{row.createdDate}</TableCell>

                  <TableCell><SwitchToggle /></TableCell>
                  <TableCell><SwitchToggle /></TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => navigate("/manage-products/detail")}>
                        <img src="/static/images/eye_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <AddProduct
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageProducts;
